import { render, staticRenderFns } from "./DetailTableLocks.vue?vue&type=template&id=70ac6289&"
import script from "./DetailTableLocks.vue?vue&type=script&lang=js&"
export * from "./DetailTableLocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports